<p-sidebar class="assign-driver-with-booking" [(visible)]="visible" position="right" [showCloseIcon]="false"
  [style]="{width:'100%'}">
  <div class="col-12 white-background common-border-radius pb-0">
    <div class="col-12 menu-header page-buttons grid align-items-center pr-0">
      <div class="col pl-2 title header block-heading flex justify-content-between align-items-center">
        <div class="grid ml-0">
          <div id="backArrow" (click)="backNavigate()" class="back-navigation-icon"></div>
          <span id="subServiceTypeStatusLabel"
            translate>{{assignBookingInfo?.subServiceTypeStatusLabel}}</span>&nbsp;<span>Journey
            Details</span>
        </div>
      </div>
      <div class="col-fixed to-third-part flex justify-content-between align-items-end pt-0 pr-0 visibility-hidden">
        <label id="lbl_to_third_party" translate>lbl_to_third_party</label>
        <p-inputSwitch id="toThirdParty" (onChange)="onSwitchChange($event)" [(ngModel)]="toThirdParty"
          [disabled]="!thirdPartyList.length"></p-inputSwitch>
      </div>
    </div>
    <div class="col-12 -mt-3 assign-driver-accordion" *ngIf="assignBookingInfo">
      <p-accordion contentStyleClass="p-2">
        <p-accordionTab [(selected)]="selectedTab">
          <ng-template pTemplate="header">
            <div class="col-12 grid py-2 px-3 flex align-items-baseline" style="align-items: center;">
              <div class="col p-0 mt-0-3" style="line-height: 2;">
                <div>
                  <span id="pickupDateTime" class="assign-time-date">{{assignBookingInfo.pickupDateTime |
                    date:'H:mm d MMM y'}}</span> |
                  <span id="tripId" translate class="booking-id"> Booking ID -
                    {{assignBookingInfo.tripId}}</span>
                  | <span id="estimatedDropoffTime" class="assign-time-date" style="font-size: 16px;color: purple;">Estimated Drop
                    Off Time
                    {{estimatedDropoffTime}}</span>
                </div>
              </div>
              <div class="col-fixed status">
                <span id="label_status" style="font-weight: normal;" translate> label_status <span>:</span></span>
                <span id="tourStatusString" class="completed pl-2">{{
                  assignBookingInfo.tourStatusString}}</span>
              </div>
            </div>
          </ng-template>
          <div class="col-12 grid text-sm" #toggleicon>
            <div class="col-4">
              <div id="label_passenger_detail" class="col-12 sub-form-heading assign-driver-accordion-heading" translate>
                label_passenger_detail</div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_passenger_name" translate>label_name</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="passengerName">{{assignBookingInfo.pFirstName}}
                    {{assignBookingInfo.pLastName}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_phone_number" translate>label_phone_number</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="phoneNumberValue">{{assignBookingInfo.pPhoneNum?
                    assignBookingInfo.pNumCountryCode + ' ' +
                    assignBookingInfo.pPhoneNum : 'NA'}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_passenger_type" translate>label_passenger_type</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="passengerType">{{assignBookingInfo.passengerType || 'NA'}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_privilege" translate>label_privilege</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="privilage">{{assignBookingInfo.privilage? assignBookingInfo.privilage:
                    'NA'}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_eligibility" translate>label_eligibility</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="eligibility">{{assignBookingInfo.eligibility? assignBookingInfo.eligibility:
                    'NA'}}</span>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="col-12 sub-form-heading assign-driver-accordion-heading visibility-hidden" translate>label_passenger_detail</div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_total_passengers" translate>label_total_passengers</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="totalNoOfPassengers">{{assignBookingInfo.totalNoOfPassengers}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_wheelchair_transported" translate>label_wheelchair_transported</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="totalNoOfWheelchairs">{{assignBookingInfo.totalNoOfWheelchairs}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_baby_seats" translate>label_baby_seats</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="totalNoOfBabyseats">{{assignBookingInfo.totalNoOfBabyseats}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_child_seat_required" translate>label_child_seat_required</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="totalNoOfChildseats">{{assignBookingInfo.totalNoOfChildseats}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_Luggage_count" translate>label_luggage_bags_required</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="totalNoOfBaggage">{{assignBookingInfo.totalNoOfLuggageBags}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_shuttle_Title" translate>label_shuttle_Title</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="tripTitle">{{assignBookingInfo.tripTitle ? assignBookingInfo.tripTitle :
                    'NA'}}</span>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div id="label_journey_details" class="col-12 sub-form-heading assign-driver-accordion-heading" translate>
                label_journey_details</div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_pickup_location" translate>label_pickup_location</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6 overflow-hidden text-overflow-ellipsis white-space-nowrap">
                  <span id="pickupLocationName" title="{{assignBookingInfo.pickupLocationName}}">{{assignBookingInfo.pickupLocationName}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_stop_location" translate>label_stop_location</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6 overflow-hidden text-overflow-ellipsis white-space-nowrap">
                  <span id="stopLocationName" title="{{getStopAddress(assignBookingInfo)}}">{{getStopAddress(assignBookingInfo)}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_drop_location" translate>label_drop_location</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6 overflow-hidden text-overflow-ellipsis white-space-nowrap">
                  <span id="dropLocationName" title="{{assignBookingInfo.dropLocationName}}">{{assignBookingInfo.dropLocationName}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_passenger_note" translate>label_passenger_note</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="passengerNote">{{assignBookingInfo.passengerNote? assignBookingInfo.passengerNote:
                    'NA'}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_address_note" translate>label_address_note</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="pickupAddressNote">{{assignBookingInfo.pickupAddressNote?
                    assignBookingInfo.pickupAddressNote:
                    'NA'}}</span>
                </div>
              </div>
              <div class="col-12 grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <label id="label_booking_note" translate>label_booking_note</label>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <span id="tripNote">{{assignBookingInfo.tripNote? assignBookingInfo.tripNote:
                    'NA'}}</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <span id="label_view_prior_booking" class="col-12 md:col-6 lg:col-3" style="cursor: pointer;color: #06A0FF;"
                (click)="showPassengerDayBookings()">
                <span translate>label_view_prior_booking</span>({{passengersTodaysActiveBookings}})
              </span>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>

    <div class="col-12" *ngIf="value === 'list'">
      <div class="grid">
        <div class="col-12 grid flex justify-content-between align-items-center pr-0 pb-0">
          <div class="col-12 md:col-10 lg:col-10">
            <div class="grid">
              <div class="col-12 md:col-4 lg:col-2 width150">
                <div class="form-label">
                  <label id="label_current_status" class="list-filter-lbl" translate>label_current_status</label>
                </div>
                <div class="form-control filter-drop-down">
                  <p-dropdown id="label_current_status" [options]="currentStatus"
                    [(ngModel)]="selectedCurrentStatus"
                    (onChange)="changeFilter('driverCurrentStatus', selectedCurrentStatus)"
                    [placeholder]="'label_current_status' | translate">
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-3 width200">
                <div class="form-label">
                  <label id="label_parking_location" class="list-filter-lbl" translate>label_parking_location</label>
                </div>
                <div class="form-control filter-drop-down">
                  <p-dropdown id="parkingLocationsOptions" [options]="parkingLocationsOptions"
                    [(ngModel)]="defaultSelectedparkingLocation"
                    (onChange)="changeFilter('parkingLocationId', defaultSelectedparkingLocation)"
                    [placeholder]="'label_parking_location' | translate">
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-2 width150">
                <div class="form-label">
                  <label id="label_sort_by" class="list-filter-lbl" translate>label_sort_by_list</label>
                </div>
                <div class="form-control filter-drop-down">
                  <p-dropdown id="sortTypeOptions" [options]="sortTypeOptions"
                    [(ngModel)]="selectedSortType" (onChange)="changeFilter('sortBy', selectedSortType)"
                    [placeholder]="'label_all' | translate">
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-2 width150">
                <div class="form-label">
                  <label id="label_team" class="list-filter-lbl" translate>label_team</label>
                </div>
                <div class="form-control filter-drop-down">
                  <p-dropdown id="teamsOptions" [options]="teamsOptions" [(ngModel)]="selectedTeam"
                    (onChange)="changeFilter('shiftId', selectedTeam)"
                    [placeholder]="'label_team' | translate">
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-3 width150">
                <div class="form-label">
                  <label id="label_radius_to_pickup" class="list-filter-lbl" translate>label_radius_to_pickup</label>
                </div>
                <div class="form-control filter-drop-down">
                  <p-dropdown id="radiusOption" [options]="radiusOption" [(ngModel)]="selectedRadius"
                    (onChange)="changeFilter('radiusToPickup', selectedRadius)"
                    [placeholder]="'label_radius_to_pickup' | translate">
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-3 width150">
                <div class="form-label">
                  <label id="label_dispatch_zones" class="list-filter-lbl" translate>label_dispatch_zones</label>
                </div>
                <div class="form-control filter-drop-down">
                  <p-dropdown id="dispatchZonesOption" [options]="dispatchZonesOption" [(ngModel)]="selectedDispatchZones"
                    (onChange)="changeFilter('serviceAreaId', selectedDispatchZones)"
                    [placeholder]="'label_all' | translate">
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-3 width150">
                <div class="form-label">
                  <label id="label_available_for" class="list-filter-lbl" translate>label_available_for</label>
                </div>
                <div class="form-control filter-drop-down">
                  <p-dropdown id="availableForService" [options]="availableForServiceOptions"
                    [(ngModel)]="selectedAvailableForService"
                    (onChange)="changeFilter('availableForService', selectedAvailableForService)"
                    [placeholder]="'label_all' | translate">
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-2 lg:col-2 grid flex justify-content-end">
            <div class="flex flex-row-reverse gap-2">
              <button id="label_apply"
                [ngClass]="filterApplied ? 'filter-btn-apply filter-applied' : 'filter-btn-apply'" pButton
                appRipple (click)="applyFilter()" type="button" icon="fa fa-check"
                [label]="'label_apply' | translate" class="ml-0"></button>
              <button id="label_reset" pButton appRipple class="reset-btn" (click)="resetFilter()"
                type="button" icon="fa fa-undo" [label]="'label_reset' | translate"></button>
            </div>
            <div class="form-control filter-drop-down mt-0-39">
              <p-selectButton id="listMapOptions" [options]="listMapOptions"
                optionLabel="label" optionValue="value" [(ngModel)]="value" (onChange)="loadList($event)">
                <ng-template let-item pTemplate="item">
                  <i [class]="item.icon"></i>&nbsp;<span>{{item.label}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
        </div>

        <div class="col-12 assign-driver p-0">
          <app-mi-grid-v2 [uniqId]="uniqId" [columnDefs]="columns" [pagination]="pagination"
            [searchPlaceHolder]="searchPlaceHolder" (rowClickedEvent)="onRowClicked($event)" (totalCount)="totalCount($event)" [isLimit]="false"
            rowSelection="multiple" [overflowShow]="true" divClass="mi-grid"></app-mi-grid-v2>
        </div>
      </div>
    </div>

    <div class="col-12" *ngIf="value === 'map'">
      <div class="col-12" style="display: flex; justify-content: flex-end;">
        <div class="form-control filter-drop-down mt-0-39">
          <p-selectButton id="listMapOptionsMap" [options]="listMapOptions"
            optionLabel="label" optionValue="value" [(ngModel)]="value" (onChange)="loadList($event)">
            <ng-template let-item pTemplate="item">
              <i [class]="item.icon"></i>&nbsp;<span>{{item.label}}</span>
            </ng-template>
          </p-selectButton>
        </div>
      </div>
      <app-assign-driver-map [bookingId]="bookingId" [dedicatedTourDaywiseDataId]="dedicatedTourDaywiseDataId"
        (sideBarHide)="backNavigate()"></app-assign-driver-map>
    </div>
  </div>
</p-sidebar>

@if(viewDaysBooking){
  <p-dialog id="viewDaysBooking" [modal]="true" header="View prior Bookings" position="center"
  [(visible)]="viewDaysBooking" [contentStyle]="{'overflow':'auto','width':'90vw'}" contentClass="py-0">
  <div class="col-12 page-buttons" *ngIf="passengerInfo">
    <app-passenger-day-bookings [passengerId]="passengerInfo.id"></app-passenger-day-bookings>
  </div>
</p-dialog>
}

<p-dialog id="upcomingBookingTitle" [modal]="true" [header]="upcomingBookingTitle" position="center"
  [(visible)]="isDisplayUpcommingList" (onHide)="closeUpcomingCompletedPopup()"
  [contentStyle]="{'overflow':'auto','width':'1000px'}">
  <div class="col-12 page-buttons" *ngIf="driverId">
    <app-upcoming-bookings [driverId]="driverId" [bookingType]="bookingType" [fromDate]="fromDate"
      [toDate]="toDate"></app-upcoming-bookings>
  </div>
</p-dialog>

<p-dialog id="showThirdPartyList" [modal]="true" position="center"
  styleClass="default-active-vehicle" [(visible)]="showThirdPartyList" [contentStyle]="{'overflow':'auto'}"
  [style]="{width: '600px'}" (onHide)="popUpCancel($event)">
  <ng-template pTemplate="header">{{'label_select_third_party_vendor' | translate}}</ng-template>
  <div class="col-12 grid" *ngFor="let reason of thirdPartyList">
    <div class="col-8" style="font-weight: bold;">{{reason?.vendorName ? reason?.vendorName : 'NA'}}</div>
    <div class="col-4 align-right">
      <button id="label_select" pButton appRipple (click)="selectCurrentVendor(reason)" type="button"
        [label]="'label_select' | translate" style="margin-right: 16px;"></button>
    </div>
  </div>
</p-dialog>
